import { InternalEnvironmentServiceClient } from '@viamrobotics/web-client/environment/v1/environment.client';

import { useClient } from '../client';

/** Get a RPC API client to make environment service calls. */
export const useEnvironmentClient = (): InternalEnvironmentServiceClient => {
  return useClient('environment');
};
